import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportBuyerSignalStatsMutation,
  ExportBuyerSignalStatsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportBuyerSignalStats = graphql(`
  mutation exportBuyerSignalStats(
    $request: BuyerSignalStatsRequest!
    $exportFormat: ExportFormatArgs!
  ) {
    exportBuyerSignalStats(BuyerSignalStatsRequest: $request, ExportFormat: $exportFormat) {
      id
    }
  }
`);

/** Kicks off an async buyer-signal-stats export; progress arrives via the fileExport subscription. */
export function useExportBuyerSignalStats(
  options?: UseMutationOptions<
    ExportBuyerSignalStatsMutation,
    unknown,
    ExportBuyerSignalStatsMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportBuyerSignalStats, options);
  return { ...rest, data: data?.exportBuyerSignalStats };
}
